import { createContext, useContext } from 'react';

import { UserType } from '@constants_common';

export type AdminOtpChallenge = {
  challengeToken: string;
  expiresAt: string;
  emailHint: string;
};

export type DashboardLoginResult =
  | { success: true; data: any }
  | { success: false; otpRequired: true; challenge: AdminOtpChallenge }
  | { success: false; otpRequired?: false; errorCode?: string };

export type VerifyAdminOtpResult =
  | { success: true; data: any }
  | { success: false; status: number; errorCode?: string }
  | undefined;

type AuthContext = {
  userType: UserType;
  dashboardLogin: (formData: FormData, userType: UserType) => Promise<DashboardLoginResult>;
  verifyAdminOtp: (challengeToken: string, otp: string) => Promise<VerifyAdminOtpResult>;
  isAuthenticated: (params: { userType: UserType; pagePath: string }) => Promise<boolean>;
  logout: (userType: string) => void;
};

export const authContext = createContext<AuthContext | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(authContext);
  if (context === undefined) {
    throw Error('authContext is undefined');
  }
  return context;
};
